var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgMenuDocument = function SvgMenuDocument(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 15 16",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EE751C",
    d: "M12.1 7.8c0-.3-.3-.5-.6-.5H6.4l-.9-1.2c-.2-.2-.5-.3-.8-.3H1.4c-.2 0-.5.1-.6.2-.2.2-.2.5-.2.7l.1.5H.6c-.3 0-.6.3-.6.6v.1l1 6.7c.1.4.4.7.8.7h10.7c.2 0 .4-.1.5-.2s.2-.3.1-.5zM14.6 6.5c-.1-.1-.3-.2-.5-.2H13l.3 2.4.6 4.2.9-5.8c0-.3 0-.5-.2-.6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11.9 2.1 10 .2C9.9.1 9.7 0 9.5 0H3.3c-.6 0-1 .5-1 1v3.7h2c.5 0 1.3-.1 1.6.3.3.3.8.8 1.2 1.3h5V2.7c.1-.2 0-.4-.2-.6m-.6.7H9.7q-.3 0-.3-.3V.9s0-.1.1-.1h.1c.4.4 1.4 1.5 1.8 1.8 0 .1 0 .2-.1.2"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMenuDocument);
export default ForwardRef;